export default __webpack_public_path__ + "static/media/rmall-project-5.e98fde37.png";